import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * This function allows us to merge tailwind classes in an overrideable way:
 * e.g., a component can have `class="font-bold"` and that can be overriden by
 * passing `class="font-normal"` on consumption.
 *
 * See BaseHeading.vue for an example usage.
 *
 * This should likely only be used on generic components, not everywhere: while
 * this supports all the functionality of `clsx`, we don't usually need that in
 * Vue as it's got it all built in, except for the tailwind merging.
 */
export const cn = (...inputs: ClassValue[]) => twMerge(clsx(inputs));
